import type { ReactNode } from "react";
import { FaUsers, FaUser, FaCalendarAlt } from "react-icons/fa";

type PrecioCardProps = {
  icon: ReactNode;
  title: string;
  subtitle: string;
  items: Array<{ label: string; price: string; note?: string }>;
};

function PrecioCard({ icon, title, subtitle, items }: PrecioCardProps) {
  return (
    <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8">
      <div className="flex items-start gap-4">
        <div className="bg-orange-500/95 text-white rounded-xl w-11 h-11 flex items-center justify-center shadow-lg flex-shrink-0">
          {icon}
        </div>
        <div className="min-w-0">
          <h4 className="text-xl sm:text-3xl font-bold text-blue-900 mb-1 sm:mb-2">
            {title}
          </h4>
          <p className="text-base sm:text-lg text-gray-600">{subtitle}</p>
        </div>
      </div>

      <div className="my-5 border-t border-gray-200" />

      <ul className="space-y-3">
        {items.map((item) => (
          <li key={item.label} className="text-lg leading-relaxed text-gray-700">
            <span className="font-semibold text-blue-900">{item.price}</span>
            <span className="text-gray-700"> {item.label}</span>
            {item.note ? (
              <span className="text-gray-600"> {item.note}</span>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
}

export function Precios() {
  return (
    <section className="py-10 sm:py-16 bg-gray-200">
      <div className="container mx-auto px-4 md:px-10">
        <h2 className="text-center text-4xl sm:text-6xl md:text-7xl font-bold text-blue-900/70 mb-8 md:mb-10 tracking-wider">
          PRECIOS
        </h2>

        <div className="max-w-6xl mx-auto">
          {/* <div className="rounded-2xl shadow-xl overflow-hidden bg-gradient-to-r from-clases-primary via-[#214C7A] to-[#0B3A6E] mb-8">
            <div className="px-6 sm:px-10 py-6 sm:py-7">
              <p className="text-white/90 text-sm sm:text-base">
                Tarifas claras y flexibles. Si tienes dudas, escríbeme y te
                recomiendo la opción ideal según tu nivel y objetivos.
              </p>
            </div>
          </div> */}

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
            <PrecioCard
              icon={<FaUsers className="text-2xl" />}
              title="Pack de 4 clases grupales"
              subtitle="Grupos organizados por nivel (4-5 personas)"
              items={[
                {
                  label: "/ hora por persona",
                  price: "15 €",
                },
              ]}
            />

            <PrecioCard
              icon={<FaUser className="text-2xl" />}
              title="Clases sueltas individuales"
              subtitle="Sesiones totalmentes personalizadas y adaptadas"
              items={[
                {
                  label: "/ hora",
                  price: "30 €",
                },
              ]}
            />

            <PrecioCard
              icon={<FaCalendarAlt className="text-2xl" />}
              title="Pack de 4 clases individuales"
              subtitle="La forma más económica y rápida de mejorar"
              items={[
                {
                  label: "/ hora",
                  price: "20 €",
                },
              ]}
            />
          </div>

          {/* <div className="mt-8 md:mt-10">
            <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8">
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 sm:items-center sm:justify-between">
                <div>
                  <p className="text-lg sm:text-xl font-bold text-blue-900">
                    ¿Quieres reservar o preguntar?
                  </p>
                  <p className="text-gray-700">
                    Respondo rápido por WhatsApp o desde el formulario.
                  </p>
                </div>

                <div className="flex flex-col sm:flex-row gap-3">
                  <a
                    href="#contacto"
                    className="inline-flex items-center justify-center rounded-full bg-clases-primary text-white px-6 py-2.5 font-semibold shadow-md hover:opacity-90 transition"
                  >
                    Ir a contacto
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://wa.me/34616077104"
                    className="inline-flex items-center justify-center rounded-full border border-clases-primary text-clases-primary bg-white px-6 py-2.5 font-semibold hover:bg-clases-primary hover:text-white transition"
                    aria-label="Contactar por WhatsApp"
                  >
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}
